// The page an embed sits on, as far as the browser lets the frame learn it
// (#2243, design D8). Indee counts joins with it and grants nothing, so a
// host that tells nothing costs the listener nothing. The query string often
// carries tracking ids or addresses, so it never leaves the frame.
export interface FrameWindow {
  parent: unknown
  location: {
    ancestorOrigins?: { length: number; item(index: number): string | null }
  }
  document: { referrer: string }
}

export function hostPage(win: FrameWindow = window): string | null {
  if (win.parent === win) return null

  const referrer = parseUrl(win.document.referrer)
  // Chrome, Edge and Safari name the top page even through Iframely's
  // wrapper; Firefox has no ancestorOrigins, so its referrer stands in.
  const ancestors = win.location.ancestorOrigins
  const top =
    ancestors && ancestors.length > 0
      ? ancestors.item(ancestors.length - 1)
      : referrer?.origin
  if (!top || top === "null") return null

  // Only the top page's own address may lend its path. An origin alone
  // arrives as "/", the same as a home page, and keeps no path.
  if (referrer?.origin !== top || referrer.pathname === "/") return top
  return `${top}${referrer.pathname}`
}

function parseUrl(value: string): URL | null {
  try {
    return value ? new URL(value) : null
  } catch {
    return null
  }
}
